<template>
    <div class="login">
        <div class="login-box">
            <div class="login-box-inner">
                <h3>登录</h3>
                <Divider />
                <Form >
                    <FormItem prop="user">
                        <Input type="text" v-model="user.email" size="large" placeholder="请输入用户名">
                            <Icon type="ios-person" slot="prepend"></Icon>
                        </Input>
                    </FormItem>
                    <FormItem prop="password">
                        <Input type="password" v-model="user.password" size="large" placeholder="请输入密码">
                            <Icon type="ios-lock" slot="prepend"></Icon>
                        </Input>
                    </FormItem>
                    <FormItem prop="password">
                        <Input type="text"  size="large" placeholder="请输入验证码" >
                            <img  src="/images/captcha" slot="append" style="height:36px;">
                        </Input>
                    </FormItem>
                    <FormItem>
                        <Checkbox label="自动登录"></Checkbox> 自动登录
                        <a href="" style="float:right">忘记密码?</a>
                    </FormItem>
                    <FormItem>
                        <Button type="primary" size="large" long @click="on_login">登录</Button>
                    </FormItem>
                </Form>
            </div>
            <div class="login-box-footer">
                <small>Powered By <a>Rico</a></small>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    data(){
        return {
            user:{
                email:'391140603@qq.com',password:'123456'
            }
        }
    },
    methods:{
        ...mapActions('user/', ['login']),
        async on_login(){
            await this.login(this.user);
            this.$router.push('/admin');
        }
    },
}
</script>